import { render, staticRenderFns } from "./AutomationsPage.vue?vue&type=template&id=478a7dfe&scoped=true"
import script from "./AutomationsPage.vue?vue&type=script&lang=js"
export * from "./AutomationsPage.vue?vue&type=script&lang=js"
import style0 from "./AutomationsPage.vue?vue&type=style&index=0&id=478a7dfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a7dfe",
  null
  
)

export default component.exports